module.exports = __webpack_public_path__ + "img/yucca-350x184.e9e7e0c5.jpg";